export class LoadingManager {
  private static _mainPageResourcesLoaded = false;
  private static _mainPageResourcesLoadedSubscribers = new Set<() => void>();

  static get mainPageResourcesLoaded() {
    return this._mainPageResourcesLoaded;
  }

  static set mainPageResourcesLoaded(value: boolean) {
    this._mainPageResourcesLoaded = value;

    if (value) {
      this._mainPageResourcesLoadedSubscribers.forEach((cb) => cb());
    }
  }

  static subscribeToMainPageResourcesLoaded(cb: () => void) {
    if (this._mainPageResourcesLoaded) {
      cb();
      return () => {};
    }

    this._mainPageResourcesLoadedSubscribers.add(cb);
    return () => {
      this._mainPageResourcesLoadedSubscribers.delete(cb);
    };
  }
}
